import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { LayoutDashboard, Inbox, FileSignature, ReceiptText, Store, Trash2, Users } from "lucide-react";
import PortalLayout from "@/components/PortalLayout";
import PendingApproval from "@/pages/PendingApproval";
import { useAuth } from "@/contexts/AuthContext";
import api from "@/lib/api";

const NAV = [
  { title: null, items: [{ label: "Dashboard", path: "/vendor", end: true, icon: LayoutDashboard, testId: "dashboard" }] },
  {
    title: "Orders",
    items: [
      { label: "Incoming Orders", path: "/vendor/orders", icon: Inbox, testId: "orders" },
      { label: "RFQ Requests", path: "/vendor/rfqs", icon: FileSignature, testId: "rfqs" },
      { label: "Invoices", path: "/vendor/invoices", icon: ReceiptText, testId: "invoices" },
    ],
  },
  { title: "Catalog", items: [{ label: "My Catalog", path: "/vendor/catalog", icon: Store, testId: "catalog" }] },
  { title: "Company", items: [{ label: "Team", path: "/vendor/team", icon: Users, testId: "team" }] },
  { title: null, items: [{ label: "Recently Deleted", path: "/vendor/recently-deleted", icon: Trash2, testId: "recently-deleted" }] },
];

export default function VendorLayout() {
  const [vendor, setVendor] = useState(null);
  const { user } = useAuth();
  const active = user?.tenant_status === "active";

  useEffect(() => {
    if (active) api.get("/vendor/profile").then((r) => setVendor(r.data)).catch(() => {});
  }, [active]);

  if (!active) return <PendingApproval portalLabel="Vendor Portal" />;

  return (
    <PortalLayout portalLabel="Vendor Portal" tenantName={vendor?.name} tenantSubtitle="Vendor Admin" navSections={NAV}>
      <Outlet />
    </PortalLayout>
  );
}
